import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { afterItems, beforeItems, differenceStats } from '../data/musik';
export function Difference() {
  return <section className="w-full bg-stone-50 px-8 py-24 sm:px-14 sm:py-32" data-id="element-71" data-mp="e3dhztchrgqk">
      <div className="mx-auto max-w-6xl" data-id="element-72" data-mp="9mh19ctt56g">
        <header className="grid gap-8 lg:grid-cols-12 lg:items-end" data-id="element-73" data-mp="58z51xffoiam">
          <div className="lg:col-span-7" data-id="element-74" data-mp="574i6dklqg3w">
            <p className="font-serif text-2xl italic leading-none text-red-700" data-id="element-75" data-mp="3mguii0kmkrx7">Skillnaden med MUSIK KLAR™</p>
            <h2 className="mt-4 font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-76" data-mp="3rgp880snzbgo">
              Från stressad lärare till <em className="text-red-700" data-id="element-77" data-mp="3diqxr6hgrz6g">trygg och förberedd.</em>
            </h2>
          </div>
          <p className="text-lg leading-relaxed text-slate-900/75 lg:col-span-5" data-id="element-78" data-mp="3ihv5rtsnjqv7">
            Tänk dig att börja veckan med musiklektionerna redan organiserade. Du vet vad du ska
            undervisa om – och du har arbetsbladen, de visuella förklaringarna, aktiviteterna,
            bedömningsmaterialet och facit.
          </p>
        </header>

        <dl className="mt-14 grid border-t border-slate-900/15 sm:grid-cols-3" data-id="element-79" data-mp="1fadd3ewbt2g7">
          {differenceStats.map((stat, index) => <div key={stat.label} className={`flex flex-col-reverse py-6 sm:pr-8 ${index > 0 ? 'border-t border-slate-900/10 sm:border-l sm:border-t-0 sm:pl-8' : ''}`} data-id="element-80" data-mp="1sznigc2j8q9s" data-mpi={index}>
              <dt className="mt-1.5 text-sm leading-snug text-slate-900/70" data-id="element-81" data-mp="10bro3e0frag6">{stat.label}</dt>
              <dd className="font-serif text-3xl leading-tight text-slate-900" data-id="element-82" data-mp="wazfmmze19ky">{stat.value}</dd>
            </div>)}
        </dl>

        <div className="mt-14 grid gap-5 lg:grid-cols-2" data-id="element-83" data-mp="1abijdhwtlthb">
          <article className="rounded-3xl border border-slate-900/10 bg-stone-100 p-8 sm:p-11" data-id="element-84" data-mp="15be0xmccqoog">
            <p className="text-sm font-semibold text-slate-900/60" data-id="element-85" data-mp="2lpnqgjsbyjgv">Innan MUSIK KLAR™</p>
            <h3 className="mt-2 font-serif text-3xl leading-tight text-slate-900/80 sm:text-4xl" data-id="element-86" data-mp="2lrqn3mnznauk">
              Känner du igen dig?
            </h3>
            <ul className="mt-8 divide-y divide-slate-900/10 border-t border-slate-900/10" data-id="element-87" data-mp="2os0o2o1cg10k">
              {beforeItems.map(item => <li key={item.title} className="flex gap-4 py-4 text-[15px] leading-relaxed text-slate-900/70" data-id="element-88" data-mp="2srj8zjt60c3e">
                  <XIcon className="mt-1 h-4 w-4 shrink-0 text-slate-900/40" aria-hidden="true" data-id="element-89" data-mp="2xsqd98w3mt5b" />
                  <span data-id="element-90" data-mp="32q8q3ad8lsil">
                    <span className="block font-semibold text-slate-900/80" data-id="element-91" data-mp="32onrn9nsxpfg">{item.title}</span>
                    {item.text}
                  </span>
                </li>)}
            </ul>
          </article>

          <article className="rounded-3xl bg-slate-900 p-8 text-stone-50 shadow-2xl shadow-slate-900/30 sm:p-11" data-id="element-92" data-mp="2f1fqn3xep2j8">
            <p className="text-sm font-semibold text-red-300" data-id="element-93" data-mp="2jso0g12nepwx">Med MUSIK KLAR™</p>
            <h3 className="mt-2 font-serif text-3xl leading-tight sm:text-4xl" data-id="element-94" data-mp="1mcrxkm6f18v4">
              Planera mindre. Undervisa mer.
            </h3>
            <ul className="mt-8 divide-y divide-white/10 border-t border-white/10" data-id="element-95" data-mp="1ratjdev87maa">
              {afterItems.map(item => <li key={item} className="flex gap-4 py-4 text-[15px] leading-relaxed text-stone-50/90" data-id="element-96" data-mp="1jr13r26fmnn1">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-red-700" data-id="element-97" data-mp="1etsfcjuoxndc">
                    <CheckIcon className="h-3 w-3 text-white" strokeWidth={3} aria-hidden="true" data-id="element-98" data-mp="19w929n9qbgmz" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </article>
        </div>

        <p className="mx-auto mt-14 max-w-2xl text-center font-serif text-2xl italic leading-snug text-slate-900/80 sm:text-3xl" data-id="element-99" data-mp="w2rji4ova7y0">
          Fokusera på dina elever – inte på att skapa allt material själv.
        </p>
      </div>
    </section>;
}